import { useNavigate } from 'react-router-dom';
import React, { useMemo } from 'react';
import { CardContent, Typography } from '@mui/material';
//style
import { StyledIcon, StyledMemberBox, StyledMemberCard } from '../../styled-components';

interface IFormInputs {
  title?: string;
  icon?: React.ReactNode;
  activeCount?: number;
  inactiveCount?: number;
  params?: { [key: string]: string | number | boolean };
  to?: string | boolean;
}

export const SiteMember: React.FC<IFormInputs> = ({ title, icon, activeCount, inactiveCount, params, to }) => {
  const navigate = useNavigate();
  const isclickable = useMemo(
    () => !!((to || String(to).length) && params && (Object.keys(params as any)?.length || String(params)?.length)),
    [to, params]
  );

  const parsedUrl = useMemo(() => {
    if (!isclickable) return '';

    const queryString = Object.keys(params!)
      .map((key, index) => {
        return index === 0
          ? `?${key}=${encodeURIComponent(params![key])}`
          : `&${key}=${encodeURIComponent(params![key])}`;
      })
      .join('');

    return `/${to}${queryString}`;
  }, [isclickable, params, to]);

  return (
    <StyledMemberBox
      data-testid={title}
      sx={{ cursor: isclickable ? 'pointer' : 'unset' }}
      onClick={() => isclickable && navigate(parsedUrl)}
    >
      <StyledIcon>{icon}</StyledIcon>
      <StyledMemberCard>
        <CardContent>
          <Typography sx={{ textAlign: 'center' }}>{title}</Typography>
        </CardContent>
        <Typography sx={{ textAlign: 'center', color: '#04A0C5' }}>
          <span data-testid={title + 'activeCount'}>Active: {activeCount}</span>
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          <span data-testid={title + 'inactiveCount'}>Inactive: {inactiveCount}</span>
        </Typography>
      </StyledMemberCard>
    </StyledMemberBox>
  );
};
